import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

export const counterSlice = createSlice({
  name: 'counter',
  initialState: {
    count: 121,
  },
  reducers: {
    increment: (state) => {
      state.count += 1;
    },
    decrement: (state) => {
      state.count -= 1;
    },
    clear: (state) => {
      state.count = 0;
    },
  },
});

export function useCounterStore() {
  const count = useSelector((state) => state.counter.count);
  const dispatch = useDispatch();
  return {
    count,
    increment: () => dispatch(increment()),
    decrement: () => dispatch(decrement()),
    clear: () => dispatch(clear()),
  };
}

export const { increment, decrement, clear } = counterSlice.actions;

export default counterSlice.reducer;
